import { RecommendationTab, RecommendationType, YoutubeItemType } from 'shared/interfaces/Youtube';

export const RECOMMENDATION_TABS: RecommendationTab[] = [
  {
    recommendationType: RecommendationType.PODCAST,
    tabName: 'Podcasts',
    videos: [
      {
        id: 'x3e73Qn6NOo',
        title: 'The Man That Makes Millionaires: How To Turn $1,000 Into $100 Million!: Alex Hormozi | E235',
        imageUrl: 'https://i.ytimg.com/vi/x3e73Qn6NOo/hqdefault.jpg',
        channelId: 'UCGq-a57w-aPwyi3pW7XLiHw',
        channelTitle: 'The Diary Of A CEO',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'hFL6qRIJZ_Y',
        title: 'ADHD & How Anyone Can Improve Their Focus',
        imageUrl: 'https://i.ytimg.com/vi/hFL6qRIJZ_Y/hqdefault.jpg',
        channelId: 'UC2D2CMWXMOVWx7giW1n3LIg',
        channelTitle: 'Andrew Huberman',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'jvqFAi7vkBc',
        title: 'Sam Altman: OpenAI, GPT-5, Sora, Board Saga, Elon Musk, Ilya, Power & AGI | Lex Fridman Podcast #419',
        imageUrl: 'https://i.ytimg.com/vi/jvqFAi7vkBc/hqdefault.jpg',
        channelId: 'UCSHZKyawb77ixDdsGog4iWA',
        channelTitle: 'Lex Fridman',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'Jk_GcwkfJGs',
        title: 'Aging is Now Optional w/ David Sinclair | EP #60',
        imageUrl: 'https://i.ytimg.com/vi/Jk_GcwkfJGs/hqdefault.jpg',
        channelId: 'UCvxm0qTrGN_1LMYgUaftWyQ',
        channelTitle: 'Peter H. Diamandis',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'Rtv-W7IE4Mw',
        title: 'Immortality Is Closer Than You Think: AI, War, Religion, Consciousness & Elon Musk | Bryan Johnson',
        imageUrl: 'https://i.ytimg.com/vi/Rtv-W7IE4Mw/hqdefault.jpg',
        channelId: 'UCnYMOamNKLGVlJgRUbamveA',
        channelTitle: 'Tom Bilyeu',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      }
    ]
  },
  {
    recommendationType: RecommendationType.EDUCATIONAL,
    tabName: 'Education',
    videos: [
      {
        id: 'QDX-1M5Nj7s',
        title: 'MIT Introduction to Deep Learning | 6.S191',
        imageUrl: 'https://i.ytimg.com/vi/QDX-1M5Nj7s/hqdefault.jpg',
        channelId: 'UCtslD4DGH6PKyG_1gFAX7sg',
        channelTitle: 'Alexander Amini',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'wvXDB9dMdEo',
        title: '1. Introduction, Financial Terms and Concepts',
        imageUrl: 'https://i.ytimg.com/vi/wvXDB9dMdEo/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: '_OkTw766oCs',
        title: '1. Introduction and Supply & Demand',
        imageUrl: 'https://i.ytimg.com/vi/_OkTw766oCs/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'YoXxevp1WRQ',
        title: 'CS50 2020 - Lecture 0 - Scratch',
        imageUrl: 'https://i.ytimg.com/vi/YoXxevp1WRQ/hqdefault.jpg',
        channelId: 'UCcabW7890RKJzL968QWEykA',
        channelTitle: 'CS50',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'Bl4Feh_Mjvo',
        title: 'Stanford CS229 Machine Learning I Introduction I 2022 I Lecture 1',
        imageUrl: 'https://i.ytimg.com/vi/Bl4Feh_Mjvo/hqdefault.jpg',
        channelId: 'UCBa5G_ESCn8Yd4vw5U-gIcg',
        channelTitle: 'Stanford Online',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      }
    ]
  },
  {
    recommendationType: RecommendationType.COMPANY_CONTENT,
    tabName: 'Company Content',
    videos: [
      {
        id: 'deDncBTgy5I',
        title: 'Google’s Principles of Innovation: How we create, launch, and iterate',
        imageUrl: 'https://i.ytimg.com/vi/deDncBTgy5I/hqdefault.jpg',
        channelId: 'UCTMRxtyHoE3LPcrl-kT4AQQ',
        channelTitle: 'Google Cloud',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'ev9o7crUd64',
        title: 'How Netflix Reinvented Work Culture',
        imageUrl: 'https://i.ytimg.com/vi/ev9o7crUd64/hqdefault.jpg',
        channelId: 'UCS0Wb3TaweMtYXDlZ_yAJ0w',
        channelTitle: 'Tech Space',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'uwutHtN-ks0',
        title: 'Hybrid work at Microsoft',
        imageUrl: 'https://i.ytimg.com/vi/uwutHtN-ks0/hqdefault.jpg',
        channelId: 'UCFtEEv80fQVKkD4h1PF-Xqw',
        channelTitle: 'Microsoft',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'pEroErfn8CY',
        title: 'Top Long-Term Risks for Investors | Research Recap | J.P. Morgan',
        imageUrl: 'https://i.ytimg.com/vi/pEroErfn8CY/hqdefault.jpg',
        channelId: 'UCBnFes2U2diA3QfR5m8l_Tw',
        channelTitle: 'jpmorgan',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'M7rm7_3xiNA',
        title: 'Corporate Client Banking & Specialized Industries Analyst Program Overview',
        imageUrl: 'https://i.ytimg.com/vi/M7rm7_3xiNA/hqdefault.jpg',
        channelId: 'UCHtxFngk49IKUfJUKXwpCQw',
        channelTitle: 'Chase',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      }
    ]
  },
  {
    recommendationType: RecommendationType.PRODUCT_CONTENT,
    tabName: 'Product Content',
    videos: [
      {
        id: 'wvXDB9dMdEo',
        title: '1. Introduction, Financial Terms and Concepts',
        imageUrl: 'https://i.ytimg.com/vi/wvXDB9dMdEo/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: '_OkTw766oCs',
        title: '1. Introduction and Supply & Demand',
        imageUrl: 'https://i.ytimg.com/vi/_OkTw766oCs/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'YoXxevp1WRQ',
        title: 'CS50 2020 - Lecture 0 - Scratch',
        imageUrl: 'https://i.ytimg.com/vi/YoXxevp1WRQ/hqdefault.jpg',
        channelId: 'UCcabW7890RKJzL968QWEykA',
        channelTitle: 'CS50',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'Bl4Feh_Mjvo',
        title: 'Stanford CS229 Machine Learning I Introduction I 2022 I Lecture 1',
        imageUrl: 'https://i.ytimg.com/vi/Bl4Feh_Mjvo/hqdefault.jpg',
        channelId: 'UCBa5G_ESCn8Yd4vw5U-gIcg',
        channelTitle: 'Stanford Online',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      }
    ]
  },
  {
    recommendationType: RecommendationType.EARNINGS_CALL,
    tabName: 'Earnings calls',
    videos: [
      {
        id: 'wvXDB9dMdEo',
        title: '1. Introduction, Financial Terms and Concepts',
        imageUrl: 'https://i.ytimg.com/vi/wvXDB9dMdEo/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: '_OkTw766oCs',
        title: '1. Introduction and Supply & Demand',
        imageUrl: 'https://i.ytimg.com/vi/_OkTw766oCs/hqdefault.jpg',
        channelId: 'UCEBb1b_L6zDS3xTUrIALZOw',
        channelTitle: 'MIT OpenCourseWare',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'YoXxevp1WRQ',
        title: 'CS50 2020 - Lecture 0 - Scratch',
        imageUrl: 'https://i.ytimg.com/vi/YoXxevp1WRQ/hqdefault.jpg',
        channelId: 'UCcabW7890RKJzL968QWEykA',
        channelTitle: 'CS50',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      },
      {
        id: 'Bl4Feh_Mjvo',
        title: 'Stanford CS229 Machine Learning I Introduction I 2022 I Lecture 1',
        imageUrl: 'https://i.ytimg.com/vi/Bl4Feh_Mjvo/hqdefault.jpg',
        channelId: 'UCBa5G_ESCn8Yd4vw5U-gIcg',
        channelTitle: 'Stanford Online',
        captionsAvailable: true,
        itemType: YoutubeItemType.VIDEO
      }
    ]
  }
];
